import React, {useEffect, useState} from 'react';
import './TextInBox.scss';
import sample from './Tire.png';

const TextInBox = (props) => {

    const [componentData , setComponentData] = useState();
    const [check , setCheck] = useState(false)

    useEffect(() => {
        setComponentData(props.ComponentData)
    } , [props.ComponentData])

    const clickHandler = () =>{

        setCheck(true)
        props.onClick()
    }

    return (

        <div className={`text-box ${check ? "" : ""}`} onClick={clickHandler}>

            <img src={sample} alt=""/>
            <p>{componentData?.title}</p>

        </div>
    );
};

export default TextInBox;